'use client';

import { ThemeProvider } from '@/lib/ThemeContext';
import { CmsProvider } from '@/lib/CmsContext';

export default function AppProviders({ cms, children }) {
  return (
    <ThemeProvider>
      <CmsProvider data={cms}>{children}</CmsProvider>
    </ThemeProvider>
  );
}
